import Slider from '../../IgGallery/Elements/Slider';

/**
 * Testimonials
 */
export default class Testimonials extends Slider {
  constructor($testimonialsSelector) {
    super($testimonialsSelector);

    this.$testimonialsSelector = $testimonialsSelector;

	  this.$element.on('initialized.owl.carousel',  () => {
		  const attributesToRemove = ['itemprop', 'itemtype', 'itemscope'];
		  const $clonedTestimonials = this.$element.find('.owl-item.cloned .testimonial');

		  $clonedTestimonials.each(function() {
			  const selector = attributesToRemove.map((attribute) => {
				return `[${attribute}]`;
			  }).join(', ');

			  const $targetElements = [$(this), ...$(this).find(selector)];

			  $targetElements.forEach((el) => {
				  attributesToRemove.forEach((attr) => {
					  $(el).removeAttr(attr);
				  });
			  });
		  });
	  });

    this.initialize({
      items: 1,
      animateIn: 'fadeIn',
      animateOut: 'fadeOut',
      mouseDrag: false,
      touchDrag: false,
      autoplay: true,
      autoplayHoverPause: true,
      loop: true,
      dots: true
    });
  }
}
